module.exports = __webpack_public_path__ + "img/undraw_Landing_page_re_6xev.d0387b75.svg";